document.addEventListener('click', function (event) {
  const tab = event.target.closest('[data-favourites-tab]');
  if (!tab) return;
  const section = tab.closest('.shop-favourites');
  if (!section) return;
  const selected = tab.dataset.favouritesTab;
  section.querySelectorAll('[data-favourites-tab]').forEach(function (button) {
    const active = button === tab;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-selected', String(active));
  });
  section.querySelectorAll('[data-favourites-panel]').forEach(function (panel) {
    const active = panel.dataset.favouritesPanel === selected;
    panel.classList.toggle('is-active', active);
    panel.hidden = !active;
  });
});
